import classcat from "classcat";
import React from "react";

import { CountryCode } from "@is/constants";

import css from "./FlagIcon.module.css";

const flagModules = import.meta.glob<string>(
  "../../../assets/icons/flags/*.svg",
  { eager: true, query: "?url", import: "default" }
);

const flagMap = Object.keys(flagModules).reduce<Record<string, string>>(
  (flags, path) => {
    const key = path.substring(
      path.lastIndexOf("/") + 1,
      path.lastIndexOf(".")
    );
    flags[key] = flagModules[path];

    return flags;
  },
  {}
);

type Props = {
  countryCode: CountryCode;
  className?: string;
};

const FlagIcon = ({ countryCode, className }: Props) => {
  const flag = flagMap[countryCode?.toLowerCase()] || "";

  return (
    <img
      src={flag}
      alt={countryCode}
      className={classcat([css.icon, className])}
    />
  );
};

export default FlagIcon;
